import valuationTemplate1 from './valuationTemplate1.vue'
import valuationTemplate2 from './valuationTemplate2.vue'
import valuationTemplate3 from './valuationTemplate3.vue'
import valuationTemplate4 from './valuationTemplate4.vue'
export default {
  name: 'addRule',
  data () {
    return {
      dialogTitle: {
        addRule: '新增计价规则',
        editRule: '编辑计价规则',
        copyRule: '复制规则'
      },
      dialogStatus: '',
      page: {
        size: 10,
        num: 1
      },
      ruleManage: {
        ruleId: '',
        systemId: '',
        ruleNameCn: '',
        ruleNameEn: '',
        ruleState: '',
        ruleType: '',
        remark: '',
        strategyId: '20171020110707_Yr2r1x61_1000005',
        ruleJson: {},
        ruleType: 6
      },
      strategyData: [],
      rules: {
        ruleState: [
          {
            required: true,
            message: '请选择规则状态',
            trigger: ['blur', 'change']
          }
        ],
        systemId: [
          {
            required: true,
            message: '请选择业务系统',
            trigger: ['blur', 'change']
          }
        ],
        type: [
          {
            required: true,
            message: '请选择规则类型',
            trigger: ['blur', 'change']
          }
        ],
        strategyId: [
          {
            required: true,
            message: '请选择计价策略',
            trigger: ['blur', 'change']
          }
        ],
        ruleNameCn: [
          {
            required: true,
            message: '请输入规则名称',
            trigger: ['blur', 'change']
          }
        ],
        ruleNameEn: [
          {
            required: true,
            message: '请输入规则英文名称',
            trigger: ['blur', 'change']
          }
        ],
        remark: [
          {
            required: true,
            message: '请输入描述',
            trigger: ['blur', 'change']
          }
        ]
      },
      singleData: {
        inputParamsPricing: {
          inputParamsPricingFlag: false
          // pricingunit: [
          //   {
          //     key: '',
          //     value: ''
          //   }
          // ]
        },
        outputParamsPricings: [
          {
            outputParamsPricing: {
              pricing: [
                {
                  type: '', // 等于大于那列
                  key: '',
                  value: ''
                }
              ],
              price: ''
            }
          }
        ]
      },
      amountData: { // 金额 调用 规则数据
        inputParamsPricing: {},
        outputParamsPricings: {
          section: [
            {
              start: '',
              end: '',
              price: ''
            }
          ],
          outputParamsPricing: [
            {
              pricing: [
                {
                  type: '',
                  key: '',
                  value: ''
                }
              ]
            }
          ]
        }
      },
      packetData: { // 包时段
        inputParamsPricing: {},
        outputParamsPricings: {
          section: [
            {
              // start: '2019-01-22',
              // end: '2019-01-25',
              time: [], // 需要把start和end合并到time数组
              price: '',
              expectPrice: ''
            }
          ],
          outputParamsPricing: [
            {
              pricing: [
                {
                  type: '',
                  key: '',
                  value: ''
                }
              ]
            }
          ]
        }
      },
      loveChild: { // 爱乐幼
        subject: 'c',
        price: '',
        discount: [
          {
            from: '',
            to: '',
            percent: ''
          }
        ],
        desc: ''
      },
      changeBilldata: null,
      templateData: [/* {
        ruleType: 1,
        strategyId: '2222222222'
      } */]
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  created () {
    if (!this.sysData.length) {
      this.$store.dispatch('getSystem') // 请求业务系统
    }
    this.querySearch()
    this.dialogStatus = 'addRule'
    /* 若是编辑页查询详情信息 */
    if (this.$route.query.ruleId && !this.$route.query.copy) {
      this.dialogStatus = 'editRule'
      this.queryDetail(this.$route.query.ruleId)
    } else if (this.$route.query.ruleId && this.$route.query.copy) {
      this.dialogStatus = 'copyRule'
      this.queryDetail(this.$route.query.ruleId)
    }
  },
  methods: {
    querySearch () {
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.size
      }
      let _self = this
      /* 查询计价策略列表 */
      this.$axios
        .post(this.$API.product.queryStrategyList, params)
        .then(function (r) {
          _self.strategyData = r.data.resData
        })
        .catch(function (error) {})
    },
    queryDetail (ruleId) {
      let params = {
        id: ruleId
      }
      let _self = this
      /* 查询计价规则详情 */
      this.$axios
        .get(this.$API.valuation.queryRuleById, { params: params })
        .then(function (r) {
          let data = r.data.resData
          _self.ruleManage = {
            ruleId: data.ruleId,
            ruleNameCn: data.ruleNameCn,
            systemId: data.sysId,
            ruleNameEn: data.ruleNameEn,
            ruleState: data.ruleState,
            ruleType: data.ruleType,
            remark: data.remark,
            strategyId: data.strategyId,
            ruleJson: JSON.parse(data.ruleJson)
          }
          let ruleData = JSON.parse(data.ruleJson)
          if (data.strategyId === '20171020110707_Yr2r1x61_1000003') { // 包时段
            if (ruleData.outputParamsPricings) {
              _self.packetData.outputParamsPricings.section = [] // 每次重新请求清空数组
              _self.packetData.outputParamsPricings.outputParamsPricing = [] // 每次重新请求清空数组
              console.log(ruleData.outputParamsPricings)
              if (ruleData.outputParamsPricings.section) {
                // _this.packetData.outputParamsPricings.section = data.outputParamsPricings.section
                for (let t of ruleData.outputParamsPricings.section) {
                  let timeop = {}
                  timeop.price = t.price
                  timeop.expectPrice = t.expectPrice
                  timeop.time = []
                  timeop.time.push(t.start)
                  timeop.time.push(t.end)
                  _self.packetData.outputParamsPricings.section.push(timeop)
                }
              }
              for (let v of ruleData.outputParamsPricings.outputParamsPricing) {
                let packetOp = {}
                packetOp.pricing = []
                for (let i of v.pricing) {
                  let keyOP = {}
                  let key = Object.keys(i)[1]
                  keyOP.key = key
                  keyOP.value = i[key].replace(/"/g, '')
                  keyOP.type = i.type
                  packetOp.pricing.push(keyOP)
                }
                _self.packetData.outputParamsPricings.outputParamsPricing.push(packetOp)
                console.log(_self.packetData.outputParamsPricings)
              }
            }
          }
          if (data.strategyId === '20171020110707_Yr2r1x61_1000002') { // 单次计价
            if (ruleData.outputParamsPricings.length) {
              _self.singleData.outputParamsPricings = [] // 每次重新请求清空数组
              _self.singleData.inputParamsPricing.pricingunit = []
              _self.singleData.inputParamsPricing.inputParamsPricingFlag = ruleData.inputParamsPricing.inputParamsPricingFlag
              for (let v of ruleData.inputParamsPricing.pricingunit) {
                let o = {}
                let key = Object.keys(v)[0]
                o.key = key
                o.value = v[key].replace(/"/g, '')
                _self.singleData.inputParamsPricing.pricingunit.push(o)
              }
              for (let v of ruleData.outputParamsPricings) {
                let op = {}
                op.outputParamsPricing = {}
                op.outputParamsPricing.price = v.outputParamsPricing.price
                op.outputParamsPricing.pricing = []
                for (let i of v.outputParamsPricing.pricing) {
                  let ruleOp = {}
                  let key = Object.keys(i)[1]
                  ruleOp.type = i.type
                  ruleOp.value = i[key].replace(/"/g, '')
                  ruleOp.key = key
                  op.outputParamsPricing.pricing.push(ruleOp)
                }
                _self.singleData.outputParamsPricings.push(op)
              }
            }
          }
          if (data.strategyId === '20171020110707_Yr2r1x61_1000001' || data.strategyId === '20171020110707_Yr2r1x61_1000000') { // 调用量阶梯收费/金额阶梯收费
            if (ruleData.outputParamsPricings) {
              _self.amountData.outputParamsPricings.section = [] // 每次重新请求清空数组
              _self.amountData.outputParamsPricings.outputParamsPricing = [] // 每次重新请求清空数组
              if (ruleData.outputParamsPricings.section) {
                _self.amountData.outputParamsPricings.section = ruleData.outputParamsPricings.section
              }
              for (let v of ruleData.outputParamsPricings.outputParamsPricing) {
                let ruleAmountOp = {}
                ruleAmountOp.pricing = []
                for (let i of v.pricing) {
                  let keyOP = {}
                  let key = Object.keys(i)[1]
                  keyOP.key = key
                  keyOP.value = i[key].replace(/"/g, '')
                  keyOP.type = i.type
                  ruleAmountOp.pricing.push(keyOP)
                }
                _self.amountData.outputParamsPricings.outputParamsPricing.push(ruleAmountOp)
              }
            }
          }
          if (data.strategyId === '20171020110707_Yr2r1x61_1000005') {
            _self.loveChild.subject = ruleData.subject
            _self.loveChild.price = ruleData.price
            _self.loveChild.discount = []
            _self.loveChild.discount = ruleData.discount
            _self.loveChild.desc = ruleData.desc
          }
          /* _self.templateData = _self.templateData.push(_self.ruleManage.ruleJson) */
        })
        .catch(function (error) {})
    },
    changeSys (val) {
      let _this = this
      this.changeRule(this.ruleManage.ruleType)
      if (this.ruleManage.type === '1') {
        let arr = []
        if (val) {
          arr.push(val)
        }
        _this.axios({ // 请求下游计费字段
          method: 'post',
          url: _this.$API.config.queryProdChargeFieldListByPage,
          // url: 'http://172.16.9.73:5010/agw/prodChargeFieldCtr/queryProdChargeFieldListByPage',
          data: { 'pageNum': 1, 'pageSize': 50, sysIds: arr }
        }).then((response) => {
          _this.changeBilldata = response.data.resData.resultList
        }).catch((error) => {
          console.log(error)
        })
      } else {
        this.changeBilldata = null
      }
    },
    changeType (val) {
      let _this = this
      this.changeRule(this.ruleManage.ruleType)
      if (val === '1') {
        let arr = []
        if (this.ruleManage.systemId) {
          arr.push(this.ruleManage.systemId)
        }
        _this.axios({ // 请求下游计费字段
          method: 'post',
          url: _this.$API.config.queryProdChargeFieldListByPage,
          // url: 'http://172.16.9.73:5010/agw/prodChargeFieldCtr/queryProdChargeFieldListByPage',
          data: { 'pageNum': 1, 'pageSize': 50, sysIds: arr }
        }).then((response) => {
          _this.changeBilldata = response.data.resData.resultList
        }).catch((error) => {
          console.log(error)
        })
      } else {
        console.log(val)
        this.changeBilldata = null
      }
      console.log(this.changeBilldata)
    },
    returnList () {
      this.$store.commit('closeTab', this.$route) // 关闭当前路由
      this.$router.push({
        path: '/valuationRule'
      })
    },
    changeRule (val) { // 计价模板的更换
      console.log(this.changeBilldata)
        if (val === 3) {
          this.ruleManage.strategyId = '20171020110707_Yr2r1x61_1000001'
          this.ruleManage.strategyName = '调用量阶梯收费'
          this.ruleManage.ruleType = 3
          this.amountData.outputParamsPricings.section = [
            {
              time: '',
              price: '',
              expectPrice: ''
            }
          ]
          this.amountData.outputParamsPricings.outputParamsPricing = [
            {
              pricing: [
                {
                  type: '',
                  key: '',
                  value: ''
                }
              ]
            }
          ]
        }
        if (val === 2) {
          this.ruleManage.strategyId = '20171020110707_Yr2r1x61_1000000'
          this.ruleManage.strategyName = '金额阶梯收费'
          this.ruleManage.ruleType = 2
          this.amountData.outputParamsPricings.section = [
            {
              time: '',
              price: '',
              expectPrice: ''
            }
          ]
          this.amountData.outputParamsPricings.outputParamsPricing = [
            {
              pricing: [
                {
                  type: '',
                  key: '',
                  value: ''
                }
              ]
            }
          ]
        } else if (val === 1) { // 单次计价
        this.ruleManage.strategyName = '单次计价收费'
        this.ruleManage.ruleType = 1
        this.ruleManage.strategyId = '20171020110707_Yr2r1x61_1000002'
        this.singleData.outputParamsPricings = [
          {
            outputParamsPricing: {
              pricing: [
                {
                  type: '',
                  key: '',
                  value: ''
                }
              ],
              price: ''
            }
          }
        ]
      } else if (val === 4){ // 包时段
        this.ruleManage.strategyId = '20171020110707_Yr2r1x61_1000003'
        this.ruleManage.strategyName = '包时段收费'
        this.ruleManage.ruleType = 4
        this.packetData.outputParamsPricings.section = [
          {
            time: '',
            price: '',
            expectPrice: ''
          }
        ]
        this.packetData.outputParamsPricings.outputParamsPricing = [
          {
            pricing: [
              {
                type: '',
                key: '',
                value: ''
              }
            ]
          }
        ]
      } else if (val === 6) { // 爱乐幼
        this.ruleManage.strategyId = '20171020110707_Yr2r1x61_1000005'
        this.ruleManage.strategyName = '爱乐幼计价策略'
        this.ruleManage.ruleType = 6
        this.loveChild = { // 爱乐幼
          subject: 'c',
          price: '',
          discount: [
            {
              from: '',
              to: '',
              percent: ''
            }
          ],
          desc: ''
        }
      }
    },
    saveRule (formName) {
      let _this = this
      console.log(this.ruleManage.strategyId)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let ruleJson = {}
          if (_this.ruleManage.strategyId === '20171020110707_Yr2r1x61_1000002') { // 单次计价
            ruleJson.inputParamsPricing = {}
            ruleJson.inputParamsPricing.pricingunit = []
            ruleJson.inputParamsPricing.inputParamsPricingFlag = this.singleData.inputParamsPricing.inputParamsPricingFlag
            if (ruleJson.inputParamsPricing.inputParamsPricingFlag) {
              for (let k of this.singleData.inputParamsPricing.pricingunit) {
                let o = {}
                let key = k.key
                if (key === '') {
                  this.$message({
                    message: '附加入参计费参数不能为空!',
                    type: 'warning'
                  })
                  return
                }
                o[key] = '\"' + k.value + '\"'
                if (k.value === '') {
                  this.$message({
                    message: '价格不能为空!',
                    type: 'warning'
                  })
                  return
                }
                ruleJson.inputParamsPricing.pricingunit.push(o)
              }
            }
            ruleJson.outputParamsPricings = []
            for (let v of this.singleData.outputParamsPricings) {
              let obj = {}
              obj.outputParamsPricing = {}
              if (v.outputParamsPricing.price === '') {
                this.$message({
                  message: '价格不能为空!',
                  type: 'warning'
                })
                return
              }
              obj.outputParamsPricing.pricing = []
              for (let i of v.outputParamsPricing.pricing) {
                let opSingle = {}
                opSingle.type = i.type
                let key = i.key
                opSingle[key] = '\"' + i.value + '\"'
                if (i.value === '') {
                  this.$message({
                    message: '计价值不能为空!',
                    type: 'warning'
                  })
                  return
                }
                if (i.type === '') {
                  this.$message({
                    message: '输入不能为空!',
                    type: 'warning'
                  })
                  return
                }
                obj.outputParamsPricing.pricing.push(opSingle)
              }
              obj.outputParamsPricing.price = v.outputParamsPricing.price
              ruleJson.outputParamsPricings.push(obj)
            }
          } else if (_this.ruleManage.strategyId === '20171020110707_Yr2r1x61_1000001' || this.ruleManage.strategyId === '20171020110707_Yr2r1x61_1000000') { // 金额 调用量
            ruleJson.inputParamsPricing = {}
            ruleJson.outputParamsPricings = {}
            ruleJson.outputParamsPricings.section = this.amountData.outputParamsPricings.section
            let verification = true
            let priceVer = false
            console.log(this.amountData.outputParamsPricings.section)
            this.amountData.outputParamsPricings.section.forEach((item, index) => {
              if (item.end && item.start && item.start !== 0 && item.end !== 0) {
                if (parseInt(item.end.replace(/-/g, "")) > parseInt(item.start.replace(/-/g, ""))) {
                  verification = true
                  if (index > 0) {
                    if (parseInt(item.start.replace(/-/g, "")) >= parseInt(this.amountData.outputParamsPricings.section[index - 1].end.replace(/-/g, ""))) {
                      verification = true
                    } else {
                      verification = false
                    }
                  }
                }
              } else {
                verification = false
              }
              if (item.price === '') {
                priceVer = true
              }
            })
            if (!verification) {
              this.$message({
                message: '区间不能有交集!',
                type: 'warning'
              })
              return
            }
            if (priceVer) {
              this.$message({
                message: '价格不能为空!',
                type: 'warning'
              })
              return
            }
            ruleJson.outputParamsPricings.outputParamsPricing = []
            for (let v of this.amountData.outputParamsPricings.outputParamsPricing) {
              let opAmount = {}
              opAmount.pricing = []
              for (let o of v.pricing) {
                let op = {}
                op.type = o.type
                let key = o.key
                op[key] = '\"' + o.value + '\"'
                if (o.value === '') {
                  this.$message({
                    message: '计价值不能为空!',
                    type: 'warning'
                  })
                  return
                }
                if (o.type === '') {
                  this.$message({
                    message: '输入不能为空!',
                    type: 'warning'
                  })
                  return
                }
                opAmount.pricing.push(op)
              }
              ruleJson.outputParamsPricings.outputParamsPricing.push(opAmount)
            }
          } else if (_this.ruleManage.strategyId === '20171020110707_Yr2r1x61_1000003'){ // 包时段
            ruleJson.inputParamsPricing = {}
            ruleJson.outputParamsPricings = {}
            ruleJson.outputParamsPricings.section = []
            for (let k of this.packetData.outputParamsPricings.section) {
              let secOP = {}
              if ((k.time && !k.time.length) || !k.time) {
                this.$message({
                  message: '区间不能为空!',
                  type: 'warning'
                })
                return
              }
              secOP.start = k.time[0]
              secOP.end = k.time[1]
              secOP.price = k.price
              secOP.expectPrice = k.expectPrice
              if (k.price === '') {
                this.$message({
                  message: '价格不能为空!',
                  type: 'warning'
                })
                return
              }
              if (k.expectPrice === '') {
                this.$message({
                  message: '预付成本不能为空!',
                  type: 'warning'
                })
                return
              }
              ruleJson.outputParamsPricings.section.push(secOP)
            }
            let verification = true
            ruleJson.outputParamsPricings.section.forEach((item, index) => {
              if (parseInt(item.end.replace(/-/g, "")) > parseInt(item.start.replace(/-/g, ""))) {
                if (index > 0) {
                  if (parseInt(item.start.replace(/-/g, "")) >= parseInt(ruleJson.outputParamsPricings.section[index - 1].end.replace(/-/g, ""))) {
                    verification = true
                  } else {
                    verification = false
                  }
                }
              } else {
                verification = false
              }
            })
            if (!verification) {
              this.$message({
                message: '区间不能有交集!',
                type: 'warning'
              })
              return
            }
            ruleJson.outputParamsPricings.outputParamsPricing = []
            for (let v of this.packetData.outputParamsPricings.outputParamsPricing) {
              let opAmount = {}
              opAmount.pricing = []
              for (let o of v.pricing) {
                let op = {}
                op.type = o.type
                let key = o.key
                op[key] = '\"' + o.value + '\"'
                if (o.value === '') {
                  this.$message({
                    message: '计价值不能为空!',
                    type: 'warning'
                  })
                  return
                }
                if (o.type === '') {
                  this.$message({
                    message: '输入不能为空!',
                    type: 'warning'
                  })
                  return
                }
                opAmount.pricing.push(op)
              }
              ruleJson.outputParamsPricings.outputParamsPricing.push(opAmount)
            }
          } else if (_this.ruleManage.strategyId === '20171020110707_Yr2r1x61_1000005') {
            this.returnResult()
            if (!_this.loveChild.desc) {
              this.$message({
                message: '请生成配置结果后保存!',
                type: 'warning'
              })
              return
            }
            ruleJson = _this.loveChild
          }
          ruleJson = JSON.stringify(ruleJson)
          let params = {}
          let sysIds = []
          if (_this.ruleManage.systemId) {
            sysIds.push(_this.ruleManage.systemId)
          }
          params.sysIds = sysIds
          params.remark = _this.ruleManage.remark
          params.ruleJson = ruleJson
          params.ruleNameCn = _this.ruleManage.ruleNameCn
          params.ruleNameEn = _this.ruleManage.ruleNameEn
          params.ruleState = _this.ruleManage.ruleState
          params.ruleType = _this.ruleManage.ruleType
          params.strategyId = _this.ruleManage.strategyId
          params.targetType = _this.ruleManage.type
          console.log(params)
          if (_this.dialogStatus === 'addRule') {
            _this.$axios({
              url: _this.$API.valuation.addChargeRule,
              method: 'post',
              data: params
            }).then((reponse) => {
              this.$message({
                message: '新增规则成功!',
                type: 'success'
              })
              this.$store.commit('closeTab', this.$route) // 关闭当前路由
              this.$router.push({
                path: '/valuationRule'
              })
            }).catch((err) => {
              console.log(err)
            })
          } else if (_this.dialogStatus === 'editRule') {
            params.ruleId = _this.ruleManage.ruleId
            _this.$axios({
              url: _this.$API.valuation.updateChargeRule,
              method: 'post',
              data: params
            }).then((reponse) => {
              this.$message({
                message: '更新规则成功!',
                type: 'success'
              })
              this.$store.commit('closeTab', this.$route) // 关闭当前路由
              this.$router.push({
                path: '/valuationRule'
              })
            }).catch((err) => {
              console.log(err)
            })
          } else{
            _this.$axios({
              url: _this.$API.valuation.addChargeRule,
              method: 'post',
              data: params
            }).then((reponse) => {
              this.$message({
                message: '复制规则成功!',
                type: 'success'
              })
              this.$store.commit('closeTab', this.$route) // 关闭当前路由
              this.$router.push({
                path: '/valuationRule'
              })
            }).catch((err) => {
              console.log(err)
            })
          }
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    changeFlag (val) { // 单次计价 切换是否入参
      if (val) {
        this.singleData.inputParamsPricing.inputParamsPricingFlag = true
        this.singleData.inputParamsPricing.pricingunit = []
        let op = {}
        op.key = ''
        op.value = ''
        this.singleData.inputParamsPricing.pricingunit.push(op)
        this.singleData.inputParamsPricing = Object.assign({}, this.singleData.inputParamsPricing)
      } else {
        this.singleData.inputParamsPricing.inputParamsPricingFlag = false
      }
    },
    addInputParams () { // 单次计价 新增入参
      console.log(this.singleData.inputParamsPricing.pricingunit)
      let op = {}
      op.key = ''
      op.value = ''
      this.singleData.inputParamsPricing.pricingunit.push(op)
      this.singleData.inputParamsPricing = Object.assign({}, this.singleData.inputParamsPricing) // 重新赋值 刷新
    },
    removeInputParams (index) { // 单次计价 删除入参
      if (this.singleData.inputParamsPricing.pricingunit.length !== 0 && this.singleData.inputParamsPricing.pricingunit.length !== 1) {
        this.singleData.inputParamsPricing.pricingunit.splice(index, 1)
      }
    },
    addGroup (op) { // 单次计价 新增计价表
      this.singleData.outputParamsPricings.push(op)
    },
    removeGroup (index) { // 单次计价 删除计价表
      if (this.singleData.outputParamsPricings.length !== 1 && this.singleData.outputParamsPricings.length !== 0) {
        this.singleData.outputParamsPricings.splice(index, 1)
      }
    },
    addSection (op) { // 金额 调用计费 添加区间
      this.amountData.outputParamsPricings.section.push(op)
    },
    removeSection (index) { // 金额 调用计费 删除区间
      if (this.amountData.outputParamsPricings.section.length !== 1 && this.amountData.outputParamsPricings.section.length !== 0) {
        this.amountData.outputParamsPricings.section.splice(index, 1)
      }
    },
    addConfigure (op) { // 金额 调用计费 新增计费配置
      this.amountData.outputParamsPricings.outputParamsPricing.push(op)
    },
    removeConfigure (index) { // 金额 调用计费 删除计费配置
      if (this.amountData.outputParamsPricings.outputParamsPricing.length !== 1 && this.amountData.outputParamsPricings.outputParamsPricing.length !== 0) {
        this.amountData.outputParamsPricings.outputParamsPricing.splice(index, 1)
      }
    },
    addpacketSection (op) { // 包时段
      this.packetData.outputParamsPricings.section.push(op)
    },
    removepacketSection (index) { // 包时段
      if (this.packetData.outputParamsPricings.section.length !== 1 && this.packetData.outputParamsPricings.section.length !== 0) {
        this.packetData.outputParamsPricings.section.splice(index, 1)
      }
    },
    addpacketConfigure (op) {
      this.packetData.outputParamsPricings.outputParamsPricing.push(op)
    },
    removepacketConfigure (index) {
      if (this.packetData.outputParamsPricings.outputParamsPricing.length !== 1 && this.packetData.outputParamsPricings.outputParamsPricing.length !== 0) {
        this.packetData.outputParamsPricings.outputParamsPricing.splice(index, 1)
      }
    },
    addDiscountMethod (op) {
      this.loveChild.discount.push(op)
    },
    removeDiscountMethod (index) {
      if (this.loveChild.discount.length !== 1 && this.loveChild.discount.length !== 0) {
        this.loveChild.discount.splice(index, 1)
      }
    },
    returnResult () {
        let str = ''
        str = 'TO ' + this.loveChild.subject + ', 基础 ' + this.loveChild.price + '元/天 '
        if (!this.loveChild.price && this.loveChild.price !== 0) {
          this.$message({
            message: '基础单价不能为空!',
            type: 'warning'
          })
          return
        }
        let verification = true
        this.loveChild.discount.forEach((op ,index) => {
          if (Number(op.from) >= Number(op.to)) {
            verification = false
          }
          if ((index + 1) < this.loveChild.discount.length &&  Number(op.to) >= Number(this.loveChild.discount[index + 1].from)) {
            verification = false
          }
          if (!op.percent && op.percent !== 0 || !op.from && op.from !== 0 || !op.to && op.to !== 0) {
            verification = false
          }
          str += op.from + '-' + op.to + '天, 折扣' + op.percent + '%;'
        })
        if (!verification) {
          this.$message({
            message: '折扣方式天数输入不合法,请修改!',
            type: 'warning'
          })
          return
        }
        this.loveChild.desc = str
    }
  },
  components: {
    'valuationTemplate1': valuationTemplate1,
    'valuationTemplate2': valuationTemplate2,
    'valuationTemplate3': valuationTemplate3,
    'valuationTemplate4': valuationTemplate4
  }
}



// WEBPACK FOOTER //
// ./src/views/valuation/ruleManage.js